export const getMachine = (state) => {
  return state.machine;
};
